import { checkoutShippingOrderNotesEntryStyles as styles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry";
import { css } from "styled-components";

styles.textArea = {
    labelProps: {
        variant: "h4",
        css: css`
            min-height: 32px;
            line-height: 32px;
            margin: 0;
            width: 100%;
        `,
    },
};
